(function () {
  var STORAGE_KEY = "inia-motion-test-hidden";
  var FLAME_SRC = window.INIA_FLAME_SRC || "./assets/inia-flame.png";
  var ENABLE_TEST_OVERLAY = window.INIA_ENABLE_TEST_OVERLAY === true;
  var PROGRESS_MIN = 65;
  var PROGRESS_HIGH_MIN = 90;
  var PROGRESS_MAX = 98;
  var HIGH_PROGRESS_CHANCE = 0.7;
  var STOCK_SEQUENCE = [46, 39, 52, 28, 34, 21, 17, 44, 31, 12, 26, 49];
  var STOCK_BY_TITLE = {
    "GLOW 4D": 35,
    "INIA FLARE": 46,
    "GLOW Wireless": 29,
    "INIA SPHERA": 19,
    "INIA CURVIER": 33,
    "INIA FLEX": 41,
    "INIA FASCIOR": 18
  };
  var root;
  var sparkleTimer;
  var flamePreload = new Image();
  flamePreload.src = FLAME_SRC;

  function toCssUrl(url) {
    return 'url("' + String(url).replace(/\\/g, "\\\\").replace(/"/g, '\\"') + '")';
  }

  function createPanel() {
    if (window.localStorage && window.localStorage.getItem(STORAGE_KEY) === "1") {
      return;
    }

    root = document.createElement("aside");
    root.className = "inia-motion-test";
    root.setAttribute("aria-label", "Mid-Year Sale motion test");
    root.innerHTML = [
      '<div class="inia-motion-test__panel">',
      '<button class="inia-motion-test__close" type="button" aria-label="Close motion test">&times;</button>',
      '<div class="inia-motion-test__content">',
      '<div>',
      '<p class="inia-motion-test__label">Mid-Year Sale</p>',
      '<p class="inia-motion-test__headline">Live motion test</p>',
      '</div>',
      '<div class="inia-motion-test__meter" aria-hidden="true"><span class="inia-motion-test__value">70%</span></div>',
      '<p class="inia-motion-test__sub">Inventory flame, shimmer sweep, and scroll reveal are active.</p>',
      '</div>',
      '</div>'
    ].join("");

    root.querySelector(".inia-motion-test__close").addEventListener("click", function () {
      root.remove();
      clearInterval(sparkleTimer);
      if (window.localStorage) {
        window.localStorage.setItem(STORAGE_KEY, "1");
      }
    });

    document.body.appendChild(root);
  }

  function createSpark() {
    if (!document.body || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return;
    }

    var spark = document.createElement("span");
    var left = Math.round(Math.random() * 100);
    var drift = Math.round((Math.random() - 0.5) * 90);
    var speed = (4.2 + Math.random() * 2.6).toFixed(2) + "s";

    spark.className = "inia-motion-test__spark";
    spark.style.left = left + "vw";
    spark.style.setProperty("--inia-drift", drift + "px");
    spark.style.setProperty("--inia-fall-speed", speed);
    document.body.appendChild(spark);
    spark.addEventListener("animationend", function () {
      spark.remove();
    });
  }

  function startSparkles() {
    for (var i = 0; i < 9; i += 1) {
      window.setTimeout(createSpark, i * 140);
    }
    sparkleTimer = window.setInterval(createSpark, 760);
  }

  function addRevealMotion() {
    var selectors = [
      ".card-wrapper",
      ".card-product",
      ".product-card-wrapper",
      ".pf-product-card",
      "[data-pf-type='ProductBox']"
    ];
    var cards = Array.prototype.slice.call(document.querySelectorAll(selectors.join(","))).slice(0, 28);

    if (!cards.length || !("IntersectionObserver" in window)) {
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.18 });

    cards.forEach(function (card, index) {
      card.classList.add("inia-motion-reveal");
      card.style.transitionDelay = Math.min(index * 45, 360) + "ms";
      observer.observe(card);
    });
  }

  function getProductCards() {
    var selectors = [
      ".card-product-new",
      ".card-wrapper",
      ".card-product",
      ".product-card-wrapper",
      ".pf-product-card",
      "[data-pf-type='ProductBox']"
    ];
    var seenCards = new WeakSet();

    return Array.prototype.slice.call(document.querySelectorAll(selectors.join(","))).map(function (candidate) {
      return getProductRoot(candidate);
    }).filter(function (card) {
      if (!card || seenCards.has(card)) {
        return false;
      }

      seenCards.add(card);

      return !card.closest(".inia-motion-test, header, .header-wrapper, .menu-drawer, .mega-menu, .shelves-menu-product-list")
        && !isNewArrivalCard(card)
        && !card.querySelector(".inia-stock-flame")
        && card.getAttribute("data-inia-stock-flame-ready") !== "1";
    }).slice(0, 24);
  }

  function getProductRoot(candidate) {
    return candidate.closest(".card-product-new")
      || candidate.closest(".product-card-wrapper")
      || candidate.closest(".card-wrapper")
      || candidate.closest(".card-product")
      || candidate.closest(".pf-product-card")
      || candidate.closest("[data-pf-type='ProductBox']");
  }

  function hasNewArrivalText(element) {
    var text = (element && element.textContent || "").replace(/\s+/g, " ").trim();
    return /New Arrivals/i.test(text) || /Refresh your look from head to toe/i.test(text);
  }

  function isNewArrivalCard(card) {
    var section = card.closest(".shopify-section, section");
    var previousSection;

    if (!section) {
      return false;
    }

    if (hasNewArrivalText(section)) {
      return true;
    }

    previousSection = section.previousElementSibling;
    while (previousSection && !previousSection.matches(".shopify-section, section")) {
      previousSection = previousSection.previousElementSibling;
    }

    return hasNewArrivalText(previousSection);
  }

  function getStockForCard(card, index) {
    var override = card.getAttribute("data-inia-stock");
    var parsedOverride = override ? parseInt(override, 10) : NaN;

    if (!Number.isNaN(parsedOverride)) {
      return parsedOverride;
    }

    var text = (card.textContent || "").replace(/\s+/g, " ");
    var matchedTitle = Object.keys(STOCK_BY_TITLE).find(function (title) {
      return text.indexOf(title) !== -1;
    });

    if (matchedTitle) {
      return STOCK_BY_TITLE[matchedTitle];
    }

    return STOCK_SEQUENCE[index % STOCK_SEQUENCE.length];
  }

  function getRandomInteger(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function getProgressPercentForCard(card) {
    var override = card.getAttribute("data-inia-progress");
    var parsedOverride = override ? parseInt(override, 10) : NaN;

    if (!Number.isNaN(parsedOverride)) {
      return Math.max(PROGRESS_MIN, Math.min(parsedOverride, PROGRESS_MAX));
    }

    if (Math.random() < HIGH_PROGRESS_CHANCE) {
      return getRandomInteger(PROGRESS_HIGH_MIN, PROGRESS_MAX);
    }

    return getRandomInteger(PROGRESS_MIN, PROGRESS_HIGH_MIN - 1);
  }

  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function setInventoryProgress(bar, progress) {
    var boundedProgress = Math.max(0, Math.min(progress, 100));
    var insetOffset = (boundedProgress * 0.04).toFixed(3);

    bar.style.setProperty("--inia-stock-progress", boundedProgress.toFixed(3));

    if (boundedProgress <= 0) {
      bar.style.setProperty("--inia-stock-fill-size", "0px");
      bar.style.setProperty("--inia-stock-end-x", "2px");
      return;
    }

    bar.style.setProperty("--inia-stock-fill-size", "calc(" + boundedProgress.toFixed(3) + "% - " + insetOffset + "px)");
    bar.style.setProperty("--inia-stock-end-x", "calc(2px + " + boundedProgress.toFixed(3) + "% - " + insetOffset + "px)");
  }

  function animateInventoryBar(bar, targetPercent, delay) {
    var duration = 1000;

    bar.style.setProperty("--inia-stock-percent", targetPercent);
    setInventoryProgress(bar, 0);

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setInventoryProgress(bar, targetPercent);
      bar.classList.add("is-running", "is-complete");
      return;
    }

    window.setTimeout(function () {
      var startedAt = null;
      bar.classList.add("is-running");

      function tick(now) {
        if (startedAt === null) {
          startedAt = now;
        }

        var elapsed = Math.min((now - startedAt) / duration, 1);
        var progress = targetPercent * easeInOutCubic(elapsed);
        setInventoryProgress(bar, progress);

        if (elapsed < 1) {
          window.requestAnimationFrame(tick);
          return;
        }

        setInventoryProgress(bar, targetPercent);
        bar.classList.add("is-complete");
      }

      window.requestAnimationFrame(tick);
    }, delay);
  }

  function createInventoryBar(stock, percent, index) {
    var bar = document.createElement("div");
    bar.className = "inia-stock-flame";
    bar.style.setProperty("--inia-flame-image", toCssUrl(FLAME_SRC));
    bar.style.setProperty("--inia-stock-percent", percent);
    setInventoryProgress(bar, 0);
    bar.innerHTML = [
      '<p class="inia-stock-flame__label">*Limited <span>',
      String(stock),
      '</span> pcs</p>',
      '<div class="inia-stock-flame__track" aria-hidden="true">',
      '<span class="inia-stock-flame__fill"></span>',
      '<span class="inia-stock-flame__glow"></span>',
      '<span class="inia-stock-flame__fire">',
      '<img class="inia-stock-flame__image" src="' + FLAME_SRC + '" alt="" loading="eager">',
      '</span>',
      '</div>'
    ].join("");
    return bar;
  }

  function addInventoryFlameBars() {
    var cards = getProductCards();

    cards.forEach(function (card, index) {
      if (card.querySelector(".inia-stock-flame") || card.getAttribute("data-inia-stock-flame-ready") === "1") {
        return;
      }

      var stock = getStockForCard(card, index);
      var percent = getProgressPercentForCard(card);
      var imageWrapper = card.querySelector(".card-product-new--info_image-wrapper, .card__media, .product-card__media, .card-media");
      var content = card.querySelector(".card-product-new--info__wrapper, .card__content, .card-information, .card__information, .product-card__content, .product-card__info") || card;
      var inventoryBar = createInventoryBar(stock, percent, index);

      card.setAttribute("data-inia-stock-flame-ready", "1");

      if (imageWrapper) {
        imageWrapper.classList.add("inia-stock-flame-host");
        inventoryBar.classList.add("inia-stock-flame--image");
        imageWrapper.appendChild(inventoryBar);
      } else {
        content.insertBefore(inventoryBar, content.firstChild);
      }

      animateInventoryBar(inventoryBar, percent, Math.min(index * 110, 660));
    });
  }

  function init() {
    addInventoryFlameBars();

    if (ENABLE_TEST_OVERLAY) {
      createPanel();
      startSparkles();
      addRevealMotion();
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
}());
